var L = /* @__PURE__ */ ((A) => (A[A.LOCAL = 1] = "LOCAL", A[A.MASTER = 2] = "MASTER", A))(L || {});
export {
  L as ProductCatalogType
};
//# sourceMappingURL=productCatalogType.enum.js.map
